<script setup>
import Footer from "@/components/Footer.vue";
import Card from "@/components/ui/card/Card.vue";
import CardContent from "@/components/ui/card/CardContent.vue";
import CardHeader from "@/components/ui/card/CardHeader.vue";
import ConfirmationView from "@/views/ConfirmationView.vue";
import HeaderView from "@/views/HeaderView.vue";
import Navigation from "@/components/Navigation.vue";
import { useEventsStore } from "@/stores/events.js";
import { useUserDataStore } from "@/stores/userData";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg");

const route = useRoute();
const router = useRouter();

const eventsStore = useEventsStore();
const userDataStore = useUserDataStore();

const currentEventId = route.params.id;

// Find event details [details, date]
const currentEvent = computed(() =>
  eventsStore.events.find((e) => e.id === currentEventId)
);
const eventName = computed(() => currentEvent.value?.name || "Unknown Event");
const description = computed(
  () => currentEvent.value?.description || "No details"
);
const eventDate = computed(() => {
  const event = currentEvent.value;
  if (!event?.startDate || !event?.endDate) return "N/A";
  const start = new Date(event.startDate.toDate());
  const end = new Date(event.endDate.toDate());
  return `${start.getDate()}/${start.getMonth() + 1} - ${end.getDate()}/${
    end.getMonth() + 1
  }`;
});

// Find user details [username, seat]
const username = computed(() => userDataStore.userProfile.nickname || "unknown_user");
const seat = computed(() =>
  eventsStore.getSeatBookingForUser(currentEvent.value, userDataStore.steamId)
);

const seatName = computed(() => {
  if (!seat.value) return "No seat booked";
  const adjustment = seat.value[1] > 2 ? -1 : 0; // Adjust for missing column
  const colLetter = String.fromCharCode(65 + seat.value[1] + adjustment);
  const rowNumber = seat.value[0];
  return colLetter + rowNumber;
});

const currentDate = ref(new Date());
const currentDateString = computed(() => {
  return `${currentDate.value.getDate()}/${currentDate.value.getMonth() + 1}`;
});

function changeBooking() {
  router.replace({ name: "SignUp", params: { id: currentEventId } });
}
</script>

<template>
  <div v-if="!isMobile" class="w-full h-20">
      <Navigation :username="userDataStore.userProfile?.nickname" :avatarUrl="userDataStore.userProfile.avatarUrl"></Navigation>
  </div>
  <div class="flex justify-center">
    <Card class="rounded-none border-none z-50 bg-background min-w-full lg:min-w-100">
      <CardHeader>
        <HeaderView name="Booking Confirmed" :check="true"></HeaderView>
      </CardHeader>
      <CardContent
        ><ConfirmationView
          :bookingDate="currentDateString"
          :user="username"
          :seat="seatName"
          :eventDate="eventDate"
          :eventDetails="description"
          :eventName="eventName"
          @onChangeClick="changeBooking"
        ></ConfirmationView>
      </CardContent>
      <Footer v-if="isMobile"></Footer>
    </Card>
  </div>
</template>
